/**
 * @file BuilderNav.tsx
 * @description Навигатор конструктора сайта — левая колонка (phase19.16
 * Р1-6а; uiux-builder-shell.md §2.1): «Страница» — переключатель страниц и
 * экранов магазина, подсказка про черновик (Р3а, SB126),
 * структура (шапка — блоки — подвал); «Весь сайт» — общие разделы.
 * `part` — только одна часть (вкладки телефона: «Страница» / «Весь сайт»).
 */

import { Info } from "lucide-react";

import { SectionLabel } from "../../ui/SectionLabel";
import { useBuilder } from "../builder-context";
import { PageStructure } from "./PageStructure";
import { PageSwitcher } from "./PageSwitcher";
import { WholeSiteList } from "./WholeSiteList";
import { cn } from "@/lib/utils";

interface Props {
  part?: "page" | "site" | "both";
  className?: string;
}

export function BuilderNav({ part = "both", className }: Props) {
  // У экрана магазина блоков нет — подсказка про сохранение блоков там лишняя
  // (у шаблона страницы товара блоки в черновике — своя подсказка в структуре).
  const onScreen = useBuilder().selection.screen !== null;
  return (
    <div className={cn("flex min-w-0 flex-col gap-3", className)}>
      {part !== "site" ? (
        <>
          <SectionLabel as="h2">Страница</SectionLabel>
          <PageSwitcher />
          {onScreen ? null : (
            <p className="type-caption flex items-start gap-2 px-1 text-on-surface-variant">
              <Info aria-hidden className="mt-0.5 size-4 shrink-0" />
              Правки страницы попадают в черновик — покупатели увидят их после «Опубликовать».
            </p>
          )}
          <SectionLabel as="h2">Структура</SectionLabel>
          <PageStructure />
        </>
      ) : null}
      {part !== "page" ? (
        <>
          <SectionLabel as="h2">Весь сайт</SectionLabel>
          <WholeSiteList showHints={part === "site"} />
        </>
      ) : null}
    </div>
  );
}
